export default [
    {
        path: '/finance/account-type',
        name: 'account-type',
        props: true,
        component: () => import('@/views/finance/account-type/index.vue'),
        meta: {
            pageTitle: 'Account Type',
            breadcrumb: [
                {
                text: 'Account Type',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/account-type/add',
        name: 'create-account-type',
        component: () => import('@/views/finance/account-type/create.vue'),
        meta: {
            pageTitle: 'Create Account Type',
            breadcrumb: [
                {
                text: 'Account Type',
                to: { name: 'account-type' },
                },
                {
                text: 'Create Account Type',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/account-type/:id',
        name: 'detail-account-type',
        props: true,
        component: () => import('@/views/finance/account-type/detail.vue'),
        meta: {
            pageTitle: 'Detail Account Type',
            breadcrumb: [
                {
                text: 'Account Type',
                to: { name: 'account-type' },
                },
                {
                text: 'Detail Account Type',
                active: true,
                },
            ],
        },
    },
]